var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCircleDashed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_6968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1023_6968)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1298 0.3C7.4098 0.27 7.6998 0.25 7.9998 0.25C8.2998 0.25 8.5798 0.27 8.8698 0.3C9.2798 0.35 9.5798 0.72 9.5298 1.13C9.4798 1.54 9.1098 1.84 8.6998 1.79C8.4698 1.76 8.2398 1.75 7.9998 1.75C7.7598 1.75 7.5298 1.76 7.2998 1.79C6.8898 1.84 6.5198 1.54 6.4698 1.13C6.4198 0.72 6.7198 0.35 7.1298 0.3Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7799 2.06005C12.0399 1.74005 12.5099 1.68005 12.8299 1.94005C13.2799 2.30005 13.6899 2.71005 14.0599 3.17005C14.3199 3.49005 14.2699 3.97005 13.9399 4.22005C13.6199 4.48005 13.1399 4.43005 12.8899 4.10005C12.5999 3.73005 12.2699 3.40005 11.8999 3.11005C11.5799 2.85005 11.5199 2.38005 11.7799 2.06005Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22005 2.06C4.48005 2.38 4.43005 2.86 4.10005 3.11C3.73005 3.4 3.40005 3.73 3.11005 4.1C2.85005 4.42 2.38005 4.48 2.06005 4.22C1.74005 3.96 1.68005 3.49 1.94005 3.17C2.30005 2.72 2.71005 2.31 3.17005 1.94C3.49005 1.68 3.97005 1.73 4.22005 2.06Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13 6.47005C1.54 6.52005 1.84 6.89005 1.79 7.30005C1.76 7.53005 1.75 7.76005 1.75 8.00005C1.75 8.24005 1.76 8.47005 1.79 8.70005C1.84 9.11005 1.54 9.48005 1.13 9.53005C0.72 9.58005 0.35 9.28005 0.3 8.87005C0.27 8.59005 0.25 8.30005 0.25 8.00005C0.25 7.70005 0.27 7.42005 0.3 7.13005C0.35 6.72005 0.72 6.42005 1.13 6.47005Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.87 6.47005C15.28 6.42005 15.65 6.72005 15.7 7.13005C15.73 7.41005 15.75 7.70005 15.75 8.00005C15.75 8.30005 15.73 8.58005 15.7 8.87005C15.65 9.28005 15.28 9.58005 14.87 9.53005C14.46 9.48005 14.16 9.11005 14.21 8.70005C14.24 8.47005 14.25 8.24005 14.25 8.00005C14.25 7.76005 14.24 7.53005 14.21 7.30005C14.16 6.89005 14.46 6.52005 14.87 6.47005Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9401 11.7799C14.2601 12.0399 14.3201 12.5099 14.0601 12.8299C13.7001 13.2799 13.2901 13.6899 12.8301 14.0599C12.5101 14.3199 12.0301 14.2699 11.7801 13.9399C11.5201 13.6199 11.5701 13.1399 11.9001 12.8899C12.2701 12.5999 12.6001 12.2699 12.8901 11.8999C13.1501 11.5799 13.6201 11.5199 13.9401 11.7799Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05976 11.7801C2.37976 11.5201 2.85976 11.5701 3.10976 11.9001C3.39976 12.2701 3.72976 12.6001 4.09976 12.8901C4.41976 13.1501 4.47976 13.6201 4.21976 13.9401C3.95976 14.2601 3.48976 14.3201 3.16976 14.0601C2.71976 13.7001 2.30976 13.2901 1.93976 12.8301C1.67976 12.5101 1.72976 12.0301 2.05976 11.7801Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4698 14.87C6.5198 14.46 6.8898 14.16 7.2998 14.21C7.5298 14.24 7.7598 14.25 7.9998 14.25C8.2398 14.25 8.4698 14.24 8.6998 14.21C9.1098 14.16 9.4798 14.46 9.5298 14.87C9.5798 15.28 9.2798 15.65 8.8698 15.7C8.5898 15.73 8.2998 15.75 7.9998 15.75C7.6998 15.75 7.4198 15.73 7.1298 15.7C6.7198 15.65 6.4198 15.28 6.4698 14.87Z",
    className: "icon-fill"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1023_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 15.5,
    fill: "white",
    transform: "translate(0.25 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleDashed);
export default __webpack_public_path__ + "static/media/icon-circle-dashed.ff11c5358ff09d8568dd7734a73e0147.svg";
export { ForwardRef as ReactComponent };